export default {
  "category.shoes": "Zapatos",
  "category.hoodies": "Sudaderas",
  "category.tshirts": "Camisetas",
  "category.jackets": "Chaquetas",
  "category.pants": "Pantalones / Shorts",
  "category.headwear": "Gorros",
  "category.sets": "Conjuntos",
  "category.underwear": "Ropa interior",
  "category.jersey": "Jersey",
  "category.accessories": "Accesorios",
  "category.bags": "Bolsos",
  "category.belts": "Cinturones",
  "category.perfumes": "Perfumes",
  "category.other": "Otros artículos",
};